(function () {
  var toggles = document.querySelectorAll(
    ".cs-header__search-toggle, .cs-search-overlay, .cs-search__close"
  );
  toggles.forEach(function (toggle) {
    toggle.addEventListener("click", function (e) {
      e.preventDefault();
      var body = document.body;
      var headerElement = document.querySelector(".cs-header");
      if (!body.classList.contains("cs-search-active")) {
        body.classList.add("cs-search-transition");
      } else {
        setTimeout(function () {
          body.classList.remove("cs-search-transition");
        }, 400);
      }
      body.classList.toggle("cs-search-active");
      headerElement.classList.toggle("cs-search-visible");
    });
  });
})();
